import { faFingerprint } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const FingerPrintIcon = (props: { color: string }) => {
  return (
    <FontAwesomeIcon icon={faFingerprint} color={props.color} />
  )
}
